import { MeasurementUnit } from "vamos/cockpit/model/odata/VamosModel";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";
import V4Context from "sap/ui/model/odata/v4/Context";
import BaseService from "vamos/cockpit/base/services/BaseService";
import ODataListBinding from "sap/ui/model/odata/v4/ODataListBinding";
import VamosComponent from "vamos/cockpit/Component";

export default class PackingUnitService extends BaseService {

    constructor(component:VamosComponent){
        super(component,"/PackingUnits");
    }
    public async findBySupplierCondition_onlyNoDecimalValues(supplierGuid:string): Promise<V4Context[]> {

        const listBinding:ODataListBinding = this.getListBinding();
        const filter: Filter = new Filter({
            filters: [
                new Filter("SupplierConditionGuid", FilterOperator.EQ, supplierGuid),
                new Filter("IsDecimalValue", FilterOperator.EQ, false)],
            and: true,
        });
        listBinding.filter(filter);
        return await listBinding.requestContexts();
    }


}